export enum MitePolicyChoose {
  STANDARD = 'STANDARD',
  EXTENDED = 'EXTENDED',
}
